// extracted by mini-css-extract-plugin
module.exports = {"container":"Signup_container__3egPc","innerContainer":"Signup_innerContainer__1YVoS","formBlock":"Signup_formBlock__KkDUT","btn":"Signup_btn__1OyQk"};